// extracted by mini-css-extract-plugin
export default {"menu":"styles_menu__REmGo","item":"styles_item__kg+IW","title":"styles_title__jDXjy","active":"styles_active__qr-OY","unactive":"styles_unactive__pA9F1"};